import React, { useEffect, useState } from 'react';
import { getMobileOperatingSystem, getParameterByName } from '../../utils/WindowHelper';
import { IDaasSignup } from '../../services/DaasSignupService';
import { useSelector } from 'react-redux';
import { selectDaasSignup, selectDaasStep } from './daasSignupSlice';
import { RegistrationErrorHandler } from '../../components/registration/RegistrationErrorHandler';
import { DaasSignupParamsHandler } from './DaasSignupParamsHandler';
import { Hmi } from '../hmi/Hmi';
import { HmiType } from '../hmi/hmi.interface';
import { LoadingScreenSignup } from '../../components/shared/LoadingScreen/LoadingScreenSignup';
import { http } from '../../services/BackendService';
import { signupError } from '../../utils/ErrorHandling';
import { buildRequestURL } from '../../utils/utils';
import { AUTH_API_URL } from '../../app.config';

type Props = {
  path?: string;
};

export const DaasSignup: React.FC<Props> = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [signupDone, setSignupDone] = useState(false);
  const [nextStep, setNextStep] = useState<string | undefined>('');
  const signup = useSelector(selectDaasSignup);
  const step = useSelector(selectDaasStep);

  const handleSignup = async (signup: IDaasSignup, lang: string | null, skipDeps: string | null) => {
    let params: { [key: string]: string } = {};

    if (lang) {
      params['lang'] = lang;
    }

    if (skipDeps) {
      params['skipDeps'] = skipDeps;
    }

    const url = buildRequestURL(`${AUTH_API_URL}/api/services/daas/signup`, params);

    signup.platform = getMobileOperatingSystem();

    const args: RequestInit = {
      method: 'POST',
      body: JSON.stringify(signup),
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    };

    try {
      const res = await http<IDaasSignup>(new Request(url, args));

      if (res.parsedBody) {
        setSignupDone(true);
        setNextStep(res.parsedBody.nextStep);
      }
    } catch (error) {
      signupError(error.value || 0);
    }
  };

  const signupSuccess = () => {
    const redirect = getParameterByName('redirect_uri');

    window.location.href = nextStep || redirect + '?error=hat_provisioning&error_reason=next_step_undefined';
  };

  useEffect(() => {
    if (step === 1 && !isSubmitting) {
      const lang = getParameterByName('lang');
      const skipDeps = getParameterByName('skip_deps');

      handleSignup(Object.assign({}, signup), lang, skipDeps);
      setIsSubmitting(true);
    }

    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, [step]);

  return (
    <DaasSignupParamsHandler>
      <RegistrationErrorHandler>
        {step === 0 && <Hmi applicationId={signup.applicationId} hmiType={HmiType.daas} />}

        {step === 1 && <LoadingScreenSignup done={signupDone} hundredPercent={() => signupSuccess()} />}
      </RegistrationErrorHandler>
    </DaasSignupParamsHandler>
  );
};
